'use strict';

module.exports = /* @ngInject */ function (translationService) {

	/**
	 * returns the translated equivalent of true/false
	 * @param bool
	 * @returns {*}
	 */
	function checkAvailability(bool){
		return bool === true ? translationService.translate(_('Ja')) : translationService.translate(_('Nein'));
	}
	return checkAvailability
}
